import _ from 'lodash';

function reportSdkError (errorMessage) {
    if (_.get(self, 'console.error')) {
        self.console.error(`Wix code SDK error: ${errorMessage}`);
    }
}

function reportSdkMsg (message) {
    if (_.get(self, 'console.error')) {
        self.console.log(`Wix code SDK message: ${message}`);
    }
}

function reportSdkWarning (message) {
    if (_.get(self, 'console.warn')) {
        self.console.warn(`Wix code SDK Warning: ${message}`);
    }
}

export default {
    reportSdkError,
    reportSdkMsg,
    reportSdkWarning
};



// WEBPACK FOOTER //
// ./js/modules/privates/reporter.es6